import { autocompleteHistoryLSKey } from '../../../configuration/Configuration.js';

export default () => {
  const rawValue = localStorage.getItem(autocompleteHistoryLSKey);
  return rawValue ? JSON.parse(rawValue) : [];
};
